import React, { FC } from 'react';
import ScrollToTop from '../../../components/layout/ScrollToTop';
import { Box, Container, Stack, Typography } from '@mui/material';

const Impressum: FC<{}> = () => {
	return (
		<>
			<ScrollToTop />
			<Container>
				<Stack spacing={4}>
					<Typography variant="h2">Impressum</Typography>

					<Box>
						<Typography>
							Das Internet-Stadtportal dortmund.de ist ein Projekt der Stadt Dortmund, vertreten durch deren
							Oberbürgermeister Thomas Westphal.
						</Typography>
					</Box>

					<Box>
						<Typography variant="h3">Anschrift und Erreichbarkeit</Typography>
						<Typography>Südwall 2-4</Typography>
						<Typography>44122 Dortmund</Typography>
						<Typography>Tel. +49 23150-0</Typography>
					</Box>
				</Stack>
			</Container>
		</>
	);
};
export default Impressum;
